import { QueryClientContext } from "../../context/QueryClientContext";
import { useListHosting } from "../../api/useHosting";
import { lang } from "../../utilities/lang";
import { extractCost } from "../../helpers/helpers";
import { useTaxContext } from "../../context/TaxContext";
import { ContextWrapper } from "../ContextWrapper";

export const Hosting = () => {
    return (
        <QueryClientContext>
            <ContextWrapper preloadTax={true}>
                <Content />
            </ContextWrapper>
        </QueryClientContext>
    );
};

const Price = ({
    title,
    price,
    discount,
    postfix,
    className,
}: {
    price: number;
    discount: number | null;
    title?: string;
    postfix?: string;
    className?: string;
}) => {
    const tax = useTaxContext((state) => state.tax);
    const hasDiscount = discount !== null;

    return (
        <div className={`hosting-price ${className}`}>
            {title ? <strong>{title}</strong> : null}
            <span className={`cost ${hasDiscount ? "discount" : ""}`}>{extractCost(price / 100, tax.tax_rate)}</span>
            {hasDiscount ? <span className={`cost`}>{extractCost(discount / 100, tax.tax_rate)}</span> : null}
            {postfix ? <span>{postfix}</span> : null}
        </div>
    );
};

const Content = () => {
    const hostingQuery = useListHosting();
    const hostingData = hostingQuery.isSuccess ? hostingQuery.data.data : [];

    return (
        <ul className={"hosting-list"}>
            {hostingData.map((hosting, index) => {
                return (
                    <li key={index} className={"hosting-entry"}>
                        <div className={"top"}>
                            <h2 className={"name"}>{hosting.name}</h2>
                        </div>
                        <div
                            className={"description"}
                            ref={(e) => {
                                if (e) {
                                    e.innerHTML = hosting.description;
                                }
                            }}
                        ></div>
                        <div className={"prices"}>
                            <Price
                                postfix={`/ ${lang.get("Jahr")}`}
                                price={hosting.price}
                                discount={hosting.price_discounted}
                                className={"subscription"}
                            />
                            <Price
                                title={lang.get("Einrichtung")}
                                price={hosting.setup_price}
                                discount={hosting.setup_price_discounted}
                                className={"setup"}
                            />
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};
